import 'babel-polyfill'
import { ConnectedRouter, connectRouter, routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { Route } from 'react-router'
import { applyMiddleware, compose, createStore } from 'redux'

import AppBar from '@material-ui/core/AppBar'
import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'

import reducers from './reducers/locationChange'

import HomePage from './pages/HomePage'
import Post from './pages/Post'

import Header from './components/Header/Header'
import Notifications from './components/Notification/Notification'

import './App.css'

import theme from './theme.js'

const history = createBrowserHistory()

const store = createStore(
  connectRouter(history)(reducers),
  compose(
    applyMiddleware(
      routerMiddleware(history)
    )
  )
)


const styles = {
  appBar: {
    background: 'rgba(0,0,0,0.2)',
    boxShadow: 'none',
    left: 0,
    width: '100vw'
  }
}

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest)
  return (
    React.createElement(component, finalProps)
  )
}

const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={routeProps => {
      return renderMergedProps(component, routeProps, rest)
    }} />
  )
}

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <div className='App'>
              <AppBar position='fixed' style={styles.appBar}>
                <Header softNav={window.location.pathname === '/'} />
              </AppBar>
              <div>
                <PropsRoute exact path='/' component={HomePage} />
                <PropsRoute exact path='/posts/:postSlug' component={Post} />
              </div>
              <Notifications.NotificationContainer />
            </div>
          </ConnectedRouter>
        </Provider>
      </MuiThemeProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js